const tablesName = [
    {
      value: 'Actions',
      label: 'Actions'
    },
    {
      value: 'Areas',
      label: 'Areas'
    },
    {
      value: 'BackupsRealmFiles',
      label: 'Backups'
    },
    {
      value: 'Companies',
      label: 'Companies'
    },
    {
      value: 'EquipmentGroups',
      label: 'Equipment Groups'
    },
    {
      value: 'EquipmentModels',
      label: 'Equipment Types'
    },
    {
      value: 'Equipments',
      label: 'Equipments'
    },
    {
      value: 'EquipmentServices',
      label: 'Equipment Services'
    },
    {
      value: 'Files',
      label: 'Files'
    },
    {
      value: 'Frequencies',
      label: 'Frequencies'
    },
    {
      value: 'Photos',
      label: 'Photos'
    },
    {
      value: 'Places',
      label: 'Places'
    },
    {
      value: 'Questions',
      label: 'Questions'
    },
    {
      value: 'Quicksights',
      label: 'Quicksights'
    },
    {
      value: 'Services',
      label: 'Services'
    },
    {
      value: 'ServiceTypes',
      label: 'Service Types'
    },
  {
    value: 'Sites',
    label: 'Sites'
  },
  {
    value: 'SupportFiles',
    label: 'Support Files'
  },
  {
    value: 'Tenants',
    label: 'Tenants'
  },
  {
    value: 'Tokens',
    label: 'Tokens'
  },
  {
    value: 'Users',
    label: 'Users'
  }
]

export default tablesName
